const CallIcon = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
        <path d="M40 20C40 31 31 40 20 40 9 40 0 31 0 20 0 9 9 0 20 0 31 0 40 9 40 20Z" fill="#6ee7b7"/>
        <path d="M14.7 12.5C13.5 13 12.7 14.7 12.6 15.9 12 19.7 15 23 17.8 25.2 20.2 27.1 24.9 30.3 27.7 27.2 28.2 26.8 28.4 26.3 28.5 25.7 28.4 24.8 27.6 24.1 26.9 23.6 26.4 23.2 25.3 22.2 24.7 22.2 24.1 22.2 23.7 22.9 23.3 23.2 23.2 23.3 22.7 23.8 22.6 23.9 22.5 24 21.1 23.1 21 23 20.4 22.6 19.8 22.2 19.3 21.7 18.9 21.2 18.4 20.7 18 20.2 17.7 19.7 17.4 19.2 17.1 18.6 17.1 18.6 17.9 17.7 18.1 17.4 18.6 16.7 18.9 16.1 18.4 15.3 18.2 15 18 14.7 17.7 14.5 17.2 14 16.7 13.6 16.2 13.2 15.9 12.9 15.5 12.7 15 12.5 14.9 12.5 14.8 12.5 14.7 12.5Z" fill="#fff" />
      </svg>
    );
  }
  
  export default CallIcon;